
export default {
  props: {
    environment: {
      type: String,
      required: true,
    },
  },
  computed: {
    discoveryToolUrl() {
      switch (this.environment.toUpperCase()) {
        case 'DEV':
          return 'http://localhost:3000/aca/discover/global-header-search-block.min.js';
        case 'QA':
          return 'https://academic-ecosystem-ingress-qa.aop.cambridge.org/aca/discover/global-header-search-block.min.js';
        case 'SI':
          return 'https://academic-ecosystem-ingress-si.aop.cambridge.org/aca/discover/global-header-search-block.min.js';
        default:
          return 'https://www.cambridge.org/aca/discover/global-header-search-block.min.js';
      }
    },
  },
  created() {
    setTimeout(() => {
      const script = document.createElement('script');
      script.src = this.discoveryToolUrl;
      script.async = true;
      document.head.appendChild(script);
    }, 50);
  },
};
